// extracted by mini-css-extract-plugin
export default {"wrapper":"vQGQZ","status":"FyOGC","message":"x3X2R","percentage":"Lda9G"};